<template>
  <v-row class="py-3">
    <v-col class="d-flex align-center " cols="12" md="6">
      <div class="d-flex flex-column">
        <v-card-subtitle class="title py-0 px-0">{{
          $t("mainStore.aboutStore.policyTitle")
        }}</v-card-subtitle>
        <h5 class="grey--text">
          {{ $t("mainStore.aboutStore.policySubtitle") }}
        </h5>
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-end" cols="12" md="6">
      <div class="d-flex align-center">
        <template v-if="readOnly">
          <v-text-field v-if="storePolicy !== undefined" :readonly="readOnly" :value="storePolicy ? storePolicy : '' " class="pt-5 pb-6 pr-3" ref="textArea">
            <v-breadcrumbs style="padding: 0px">
              {{ storePolicyInput }}
              <v-btn icon :href="storePolicyInput" target="blank"
                ><v-icon v-if="storePolicyInput">mdi-open-in-new</v-icon></v-btn
              ></v-breadcrumbs
            >
          </v-text-field>
          <v-btn icon @click="enableEditMode">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-text-field
            ref="textArea"
            v-model="storePolicyInput"
            @keyup.enter="saveChanges"
            @keyup.esc="cancelChanges"
          ></v-text-field>
          <v-btn icon color="success" @click="saveChanges">
            <v-icon>mdi-check-circle-outline</v-icon>
          </v-btn>
          <v-btn icon color="info" @click="cancelChanges">
            <v-icon>mdi-restart</v-icon>
          </v-btn>
        </template>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "StorePolicyVue",
  props: {
    storePolicy: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      readOnly: true,
      storePolicyInput: this.storePolicy,
    };
  },
  methods: {
    enableEditMode() {
      this.readOnly = false;
      this.$nextTick(() => {
        this.$refs.textArea.focus();
      });
    },
    saveChanges() {
      this.readOnly = true;
      this.$emit("update:storePolicy", this.storePolicyInput);
    },
    cancelChanges() {
      this.storePolicyInput = this.storePolicy;
      this.readOnly = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
